import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import {
  BulkChangeBillingRunsPage,
  BulkChangeBillingRunDetailsPage,
  BulkChangeBillingSelectReservationsPage,
} from './pages';

export const BulkChangeBillingRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={match.path} exact component={BulkChangeBillingRunsPage} />
    <Route path={`${match.path}/new`} exact component={BulkChangeBillingSelectReservationsPage} />
    <Route path={`${match.path}/:runId`} exact component={BulkChangeBillingRunDetailsPage} />
    <Redirect to={match.path} />
  </Switch>
);
